import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import keycloak from './Keycloak';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);

keycloak.init({ 
    onLoad: 'login-required',
    checkLoginIframe: false,
    enableLogging: true,
    pkceMethod: 'S256',
    token: sessionStorage.getItem('kc_token'),
    refreshToken: sessionStorage.getItem('kc_refreshToken')
}).then((authenticated) => {
    if (authenticated) {
        console.log('User is authenticated');

        // Store tokens in sessionStorage
        sessionStorage.setItem('kc_token', keycloak.token);
        sessionStorage.setItem('kc_refreshToken', keycloak.refreshToken);

        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    } else {
        console.log('User is not authenticated, showing login button');
        // Show a login button instead of automatically redirecting
        root.render(
            <div style={{ textAlign: 'center', marginTop: '50px', fontFamily: 'Arial, sans-serif' }}>
                <h1>Welcome</h1>
                <p>Please log in to access the application.</p>
                <button 
                    onClick={() => keycloak.login()} 
                    style={{ padding: '10px 20px', marginTop: '20px', cursor: 'pointer' }}
                >
                    Log In
                </button>
            </div>
        );
    }

    // Token refresh setup
    setInterval(() => {
        keycloak.updateToken(70).then((refreshed) => {
            if (refreshed) {
                console.log('Token refreshed');
                // Update stored tokens
                sessionStorage.setItem('kc_token', keycloak.token);
                sessionStorage.setItem('kc_refreshToken', keycloak.refreshToken);
            } else {
                console.warn('Token not refreshed, valid for ', Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000), ' seconds');
            }
        }).catch(() => {
            console.error('Failed to refresh token');
            // If token refresh fails, redirect to login
            keycloak.login();
        });
    }, 60000);

}).catch((err) => {
    console.error('Failed to initialize Keycloak', err);
    // If initialization fails, show an error message instead of a white screen
    document.getElementById('root').innerHTML = `
        <div style="text-align: center; margin-top: 50px; font-family: Arial, sans-serif;">
            <h1>Authentication Error</h1>
            <p>There was a problem connecting to the authentication service.</p>
            <p>Please try again later or contact support if the problem persists.</p>
            <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 20px; cursor: pointer;">
                Try Again
            </button>
        </div>
    `;
});
